<div class="modal-content page-publish-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" (click)="cancelEvent.emit()"></button>
  </div>
  <div class="modal-body">
    <div class="t-1">
      <div class="toastr-relative toastr-sm toastr-no-shadow my-4 custom-alert" toastContainer></div>
    </div>
    <form [formGroup]="newDnsForm">
      <div class="page__form-wrap">
        <div class="d-flex">
          <!-- <div class="col-sm-2"> -->
          <label for="domainName" class="col-sm-2">{{ text }}</label>
          <!-- </div> -->
          <div class="w-100">
            <input type="text" placeholder="{{ placeholder }}" class="form-control" id="domainName" formControlName="domainName" />
            <wsb-validation-error-msg [fc]="newDnsForm.get('domainName')"></wsb-validation-error-msg>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <img class="img-fluid" style="width:500px" src="/assets/images/email/dns_example.png" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
    <wsb-atlas-button
      variant="primary"
      [disabled]="newDnsForm.pristine || newDnsForm.invalid"
      (btnClick)="add.emit(getFormValue())"
      [label]="labelSaveButton"
    ></wsb-atlas-button>
  </div>
</div>
